export const transition_effects = [
    {name: "fade", label: "Fade"},
    {name: "wipeleft", label: "Wipe Left"},
    {name: "wiperight", label: "Wipe Right"},
    {name: "wipeup", label: "Wipe Up"},
    {name: "wipedown", label: "Wipe Down"},
    {name: "slideleft", label: "Slide Left"},
    {name: "slideright", label: "Slide Right"},
    {name: "slideup", label: "Slide Up"},
    {name: "slidedown", label: "Slide Down"},
    {name: "circlecrop", label: "Circle Crop"},
    {name: "rectcrop", label: "Rectangle Crop"},
    {name: "distance", label: "Distance Fade"},
    {name: "fadeblack", label: "Fade to Black"},
    {name: "fadewhite", label: "Fade to White"},
    {name: "radial", label: "Radial Fade"},
    {name: "smoothleft", label: "Smooth Left"},
    {name: "smoothright", label: "Smooth Right"},
    {name: "smoothup", label: "Smooth Up"},
    {name: "smoothdown", label: "Smooth Down"},
    {name: "circleopen", label: "Circle Open"},
    {name: "circleclose", label: "Circle Close"},
    {name: "vertopen", label: "Vertical Open"},
    {name: "vertclose", label: "Vertical Close"},
    {name: "horzopen", label: "Horizontal Open"},
    {name: "horzclose", label: "Horizontal Close"},
    {name: "dissolve", label: "Dissolve"},
    {name: "pixelize", label: "Pixelize"},
    {name: "diagtl", label: "Diagonal Top Left"},
    {name: "diagtr", label: "Diagonal Top Right"},
    {name: "diagbl", label: "Diagonal Bottom Left"},
    {name: "diagbr", label: "Diagonal Bottom Right"},
    {name: "hlslice", label: "Horizontal Left Slice"},
    {name: "hrslice", label: "Horizontal Right Slice"},
    {name: "vuslice", label: "Vertical Up Slice"},
    {name: "vdslice", label: "Vertical Down Slice"},
    {name: "hblur", label: "Horizontal Blur"},
    {name: "fadegrays", label: "Fade to Grayscale"},
    {name: "wipetl", label: "Wipe Top Left"},
    {name: "wipetr", label: "Wipe Top Right"},
    {name: "wipebl", label: "Wipe Bottom Left"},
    {name: "wipebr", label: "Wipe Bottom Right"},
    {name: "squeezeh", label: "Squeeze Horizontal"},
    {name: "squeezev", label: "Squeeze Vertical"},
    {name: "zoomin", label: "Zoom In"},
    {name: "fadefast", label: "Fast Fade"},
    {name: "fadeslow", label: "Slow Fade"},
    {name: "hlwind", label: "Horizontal Left Wind"},
    {name: "hrwind", label: "Horizontal Right Wind"},
    {name: "vuwind", label: "Vertical Up Wind"},
    {name: "vdwind", label: "Vertical Down Wind"},
    {name: "coverleft", label: "Cover Left"},
    {name: "coverright", label: "Cover Right"},
    {name: "coverup", label: "Cover Up"},
    {name: "coverdown", label: "Cover Down"},
    {name: "revealleft", label: "Reveal Left"},
    {name: "revealright", label: "Reveal Right"},
    {name: "revealup", label: "Reveal Up"},
    {name: "revealdown", label: "Reveal Down"}
  ]


